import { getQueryParams } from '../../components/helpers';
import conf from '../../conf';
import { setFeaturesLoaded } from '../../store/data';
import { toggleFeature } from '../../store/features';
import fetch from '../fetch';

import type { Dispatch } from '@avalara/types/actions';

export const configureFeatures = (search: string) => async (dispatch: Dispatch) => {
  try {
    const response = await fetch(dispatch, { showLoadingWheel: false })<Record<string, boolean>>(
      `${conf.API_URL}/api/features`,
    );

    if (response.ok) {
      for (const feature of Object.keys(response.value)) {
        dispatch(toggleFeature({ feature, showFeature: response.value[feature] }));
      }
    }
  } catch {
    // The fetch helper already converts network/transport failures into a Result with ok: false;
    // this only guards against something above it (e.g. getOwdBearerToken) rejecting outright, so
    // featuresLoaded below still fires instead of leaving every gated consumer stuck forever.
  }

  const queryParams = getQueryParams(search);

  for (const feature of Object.keys(queryParams)) {
    const featureValue = queryParams[feature];
    if (typeof featureValue === 'string') {
      const showFeature = featureValue.toUpperCase() === 'TRUE';
      dispatch(toggleFeature({ feature, showFeature }));
    } else {
      dispatch(toggleFeature({ feature, showFeature: !!featureValue }));
    }
  }

  dispatch(setFeaturesLoaded());
};
